import { createContext, useContext } from 'react';
import { DocumentRequirement } from './SingleUploadBox';

export type DocumentationContextType = {
    requirements: DocumentRequirement[];
    createUploadDocumentHandler: (documentType: string) => (data: FormData) => Promise<void>;
    deleteDocument: (documentId: string) => Promise<void>;
    trustedUpload: () => Promise<void>;
    completeUpload: () => Promise<void>;
    country: Country;
};

export const DocumentationContext = createContext<DocumentationContextType | null>(null);

export function useDocumentationContext() {
    const context = useContext(DocumentationContext);
    if (!context) {
        throw new Error('useDocumentationContext hook is only useable in tree under DocumentationContextProvider element.');
    }
    return context;
}
